import { type RequestOptions, clientPanich } from "../client.panich";
import { type operations } from "../client.panich/schema";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type CheckoutOperation = operations["checkout_checkout_get"];
export type CheckoutProps = CheckoutOperation["parameters"]["query"];
export type CheckoutReturn = CheckoutOperation["responses"]["200"]["content"]["application/json"];

export const getCheckout = async (props: CheckoutProps, requestOptions?: RequestOptions): Promise<CheckoutReturn> => {
  const { data } = await clientPanich.GET(
    `/checkout`,
    {
      params: {
        query: {
          selectedItems: props.selectedItems,
        },
      },
      credentials: "include",
      ...requestOptions,
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout/change-checkout-address
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type ChangeCheckoutAddressOperation = operations["change_checkout_address_checkout_change_checkout_address_put"];
export type ChangeCheckoutAddressProps = ChangeCheckoutAddressOperation["requestBody"]["content"]["application/json"];
export type ChangeCheckoutAddressReturn = ChangeCheckoutAddressOperation["responses"]["200"]["content"]["application/json"];

export const changeCheckoutAddress = async (props: ChangeCheckoutAddressProps, requestOptions?: RequestOptions): Promise<ChangeCheckoutAddressReturn> => {
  const { data } = await clientPanich.PUT(
    `/checkout/change-checkout-address`,
    {
      body: props,
      credentials: "include",
      ...requestOptions,
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout/get-shipping-fee
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type GetShippingFeeOperation = operations["get_shipping_fee_checkout_get_shipping_fee_get"];
export type GetShippingFeeProps = GetShippingFeeOperation["parameters"]["query"];
export type GetShippingFeeReturn = GetShippingFeeOperation["responses"]["200"]["content"]["application/json"];

export const getShippingFee = async (props: GetShippingFeeProps, requestOptions?: RequestOptions): Promise<GetShippingFeeReturn> => {
  const { data } = await clientPanich.GET(
    `/checkout/get-shipping-fee`,
    {
      params: {
        query: props,
      },

      ...requestOptions,
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout/validate-shop-coupon
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type ValidateShopCouponOperation = operations["validate_shop_coupon_checkout_validate_shop_coupon_get"];
export type ValidateShopCouponProps = ValidateShopCouponOperation["parameters"]["query"];
export type ValidateShopCouponReturn = ValidateShopCouponOperation["responses"]["200"]["content"]["application/json"];

export const validateShopCoupon = async (props: ValidateShopCouponProps, requestOptions?: RequestOptions): Promise<ValidateShopCouponReturn> => {
  const { data } = await clientPanich.GET(
    `/checkout/validate-shop-coupon`,
    {
      params: {
        query: props,
      },
      credentials: "include",
      ...requestOptions,
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout/validate-platform-coupon
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type ValidatePlatformCouponOperation = operations["validate_platform_coupon_checkout_validate_platform_coupon_get"];
export type ValidatePlatformCouponProps = ValidatePlatformCouponOperation["parameters"]["query"];
export type ValidatePlatformCouponReturn = ValidatePlatformCouponOperation["responses"]["200"]["content"]["application/json"];

export const validatePlatformCoupon = async (props: ValidatePlatformCouponProps, requestOptions?: RequestOptions): Promise<ValidatePlatformCouponReturn> => {
  const { data } = await clientPanich.GET(
    `/checkout/validate-platform-coupon`,
    {
      params: {
        query: {
          code: props.code,
          amount: props.amount,
          qty: props.qty,
        },
      },
      credentials: "include",
      ...requestOptions,
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /checkout/buy-now
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type BuyNowOperation = operations["buy_now_checkout_buy_now_post"];
export type BuyNowProps = BuyNowOperation["requestBody"]["content"]["application/json"];
export type BuyNowReturn = BuyNowOperation["responses"]["200"]["content"]["application/json"];

export const buyNow = async (props: BuyNowProps, requestOptions?: RequestOptions): Promise<BuyNowReturn> => {
  const { data } = await clientPanich.POST(
    "/checkout/buy-now",
    {
      body: props,
      credentials: "include",
      ...requestOptions,
    },
  );

  return data;
};
